import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGraduationCap, faCalendarAlt, faSchool, faBriefcase, faFileAlt } from '@fortawesome/free-solid-svg-icons';
import './qualification.css'
import portfolioData from '../../portfolio.json';

const Qualification = () => {
  const [toggleState, setToggleState] = useState(1);
  const { qualification } = portfolioData;

  const toggleTab = (index) => {
    setToggleState(index);
  };

  return (
    <section className="qualification section">
      <h2 className="section__title">{qualification.title}</h2>
      <span className="section__subtitle">{qualification.subtitle}</span>

      <div className="qualification__container container">
        <div className="qualification__tabs">
          {qualification.tabs.map((tab, index) => (
            <div
              key={index}
              className={`qualification__button ${toggleState === index + 1 ? "qualification__active" : ""}`}
              onClick={() => toggleTab(index + 1)}
            >
              <FontAwesomeIcon
                icon={
                  index === 0 ? faBriefcase :
                    (index === 1 ? faGraduationCap : faSchool)
                }
                className="qualification__icon"
              /> {tab}
            </div>
          ))}
        </div>

        <div className="qualification__sections">
          {qualification.sections.map((section, sectionIndex) => (
            <div key={sectionIndex} className={toggleState === sectionIndex + 1 ? "qualification__content qualification__content-active" : "qualification__content"}>
              {section.map((item, itemIndex) => {
                // Logic to alternate left/right alignment in vertical timeline
                // Even index: left (title/subtitle) + right blank
                // Odd index: right blank + left (title/subtitle)
                // Wait, the original css logic was:
                // Div 1: Content
                // Div 2: Line
                // For odd items (1st, 3rd) -> Content, Line
                // For even items (2nd, 4th) -> Empty, Line, Content (actually structure is tailored)

                // The structure in original code:
                // Item 1: div(content), div(line)
                // Item 2: div(empty), div(line), div(content)
                // This creates the zigzag.

                if (itemIndex % 2 === 0) {
                  return (
                    <div className="qualification__data" key={itemIndex}>
                      <div>
                        <h3 className="qualification__title">{item.title}</h3>
                        <span className="qualification__subtitle">{item.subtitle}</span>
                        <div className="qualification__calendar">
                          <FontAwesomeIcon icon={faCalendarAlt} /> {item.calendar}
                        </div>
                      </div>
                      <div>
                        <span className="qualification__rounder"></span>
                        <span className="qualification__line"></span>
                      </div>
                    </div>
                  )
                } else {
                  return (
                    <div className="qualification__data" key={itemIndex}>
                      <div></div>
                      <div>
                        <span className="qualification__rounder"></span>
                        <span className="qualification__line"></span>
                      </div>
                      <div>
                        <h3 className="qualification__title">{item.title}</h3>
                        <span className="qualification__subtitle">{item.subtitle}</span>
                        <div className="qualification__calendar">
                          <FontAwesomeIcon icon={faCalendarAlt} /> {item.calendar}
                        </div>
                      </div>
                    </div>
                  )
                }
              })}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Qualification;